import type { ReactNode } from 'react';

/**
 * Shared section shells for keyword landing pages (homepage and trend
 * pages). Each section carries `data-keyword-module` so the keyword
 * coverage diagnostic can attribute mentions to modules.
 */
export function ContentSection({
  id,
  moduleName,
  title,
  children,
}: {
  id: string;
  moduleName: string;
  title: string;
  children: ReactNode;
}) {
  return (
    <section
      id={id}
      className="scroll-mt-24 space-y-4"
      data-keyword-module={moduleName}
      data-section={moduleName}
      aria-labelledby={`${id}-title`}
    >
      <h2
        id={`${id}-title`}
        className="font-serif text-2xl tracking-normal sm:text-3xl"
      >
        {title}
      </h2>
      {children}
    </section>
  );
}

export function DataTable({
  columns,
  rows,
}: {
  columns: readonly string[];
  rows: readonly (readonly string[])[];
}) {
  return (
    <div className="overflow-x-auto rounded-lg border border-white/10">
      <table className="w-full min-w-[36rem] text-left text-sm">
        <thead className="bg-white/[0.05] text-white/85">
          <tr>
            {columns.map((column) => (
              <th key={column} scope="col" className="px-4 py-3">
                {column}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="divide-y divide-white/10 text-white/72">
          {rows.map((row) => (
            <tr key={row[0]}>
              {row.map((cell, index) => (
                <td
                  key={cell}
                  className={
                    index === 0
                      ? 'px-4 py-3 font-semibold text-white'
                      : 'px-4 py-3'
                  }
                >
                  {cell}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
